import { readRuntimeConfigValue } from "runtime-config";

const serializeJsonLd = (value: unknown) =>
  JSON.stringify(value)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026");

export const SeoJsonLd = ({
  frontUrl = readRuntimeConfigValue("frontUrl", "FRONT_URL") ?? "",
  assetsUrl = readRuntimeConfigValue("assetsUrl", "ASSETS_URL") ?? "",
}: {
  frontUrl?: string;
  assetsUrl?: string;
}) => {
  const logo = `${assetsUrl}images/asset/christopher-czermak-5hLmzaCSBVA-unsplash.jpg/720/christopher-czermak-5hLmzaCSBVA-unsplash.jpg?ratio=62.5`;

  return (
    <script
      type="application/ld+json"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD must be emitted as raw script content, serialized from a static object above.
      dangerouslySetInnerHTML={{
        __html: serializeJsonLd({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Intermèdes",
          url: `${frontUrl}/`,
          logo,
          sameAs: [
            "https://www.instagram.com/intermedes/",
            "https://twitter.com/intermedesparis",
            "https://www.facebook.com/intermedesvoyages/",
            "https://www.youtube.com/channel/UC-65Cq5Qi0PsMd4QVoie3Dw",
          ],
          address: {
            "@type": "PostalAddress",
            addressCountry: "France",
            addressLocality: "Paris",
            postalCode: "75006",
            streetAddress: "10, rue de Mézières",
          },
          contactPoint: [
            {
              "@type": "ContactPoint",
              telephone: "+33145619090",
              contactType: "Service clients",
              areaServed: "FR",
              availableLanguage: "fr",
            },
          ],
        }),
      }}
    />
  );
};
